import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Warmup: Snatch Balance 4×4`}</p>
    <p>{`Hang Squat Snatch 4×4\\@80% 1RM`}</p>
    <p>{`then,`}</p>
    <p><em parentName="p">{`CrossFit Open Workout 16.3`}</em></p>
    <p>{`7:00 amrap of:`}</p>
    <p>{`10 Power Snatches (75/55)`}</p>
    <p>{`3 Bar Muscle Ups`}</p>
    <p>{`Scaled Workout:`}</p>
    <p>{`7:00 amrap of:`}</p>
    <p>{`10 Power Snatches (45/35)`}</p>
    <p>{`5 Jumping CTB Pullups `}<em parentName="p">{`(bar 6″ above head)`}</em></p>
    <p><strong parentName="p"><em parentName="strong">{`*`}{`This Saturday is our free workout at 9:00 & 10:00am so bring a
friend!`}</em></strong></p>
    <p><strong parentName="p">{`*`}{`This Saturday is also our Rowing clinic at 11:00am. Free for all
Ville members!  Sign up sheet is located by the white board.`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      